import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { PageHero } from "@/components/site/SiteLayout";
import { api, formatError } from "@/lib/api";

export const About = () => (
  <div data-testid="about-page">
    <PageHero eyebrow="About us" title="Built for the way Australian teams work." intro="Clockaroo is a workforce management platform for Australian businesses — from cafés and restaurants to trades and multi-site teams." />
    <section className="mx-auto grid max-w-7xl gap-10 px-4 py-16 sm:px-6 lg:grid-cols-2 lg:px-8">
      <img src="/img/team.jpg" alt="Team briefing" className="h-80 w-full rounded-3xl object-cover" />
      <div className="space-y-4 text-slate-600">
        <h2 className="text-2xl font-bold text-[#0B2D5B]">Our mission</h2>
        <p>Give business owners one simple place to manage who's working, when and where — and give employees a clock-in experience that just works.</p>
        <p>We design for transparency: staff always know when location is used, and every change to attendance records is kept in an audit trail.</p>
        <p className="text-sm text-slate-400">[Company story, founders and location to be supplied]</p>
      </div>
    </section>
  </div>
);

export const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", business_name: "", message: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/contact", form);
      toast.success("Thanks — we'll be in touch soon.");
      setForm({ name: "", email: "", business_name: "", message: "" });
    } catch (err) {
      toast.error(formatError(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div data-testid="contact-page">
      <PageHero eyebrow="Contact" title="Talk to the Clockaroo team." intro="Questions about features, pricing or getting set up? Send us a message." />
      <section className="mx-auto grid max-w-7xl gap-10 px-4 py-16 sm:px-6 lg:grid-cols-12 lg:px-8">
        <form onSubmit={submit} className="space-y-4 rounded-2xl border border-slate-200 p-6 lg:col-span-7" data-testid="contact-form">
          <div className="grid gap-4 sm:grid-cols-2">
            <div className="space-y-1.5"><Label>Name</Label><Input required value={form.name} onChange={set("name")} data-testid="contact-name" /></div>
            <div className="space-y-1.5"><Label>Email</Label><Input required type="email" value={form.email} onChange={set("email")} data-testid="contact-email" /></div>
          </div>
          <div className="space-y-1.5"><Label>Business name</Label><Input value={form.business_name} onChange={set("business_name")} data-testid="contact-business" /></div>
          <div className="space-y-1.5"><Label>Message</Label><Textarea required rows={5} value={form.message} onChange={set("message")} data-testid="contact-message" /></div>
          <Button disabled={busy} className="rounded-full bg-[#00C16B] hover:bg-[#00A85C]" data-testid="contact-submit">{busy ? "Sending…" : "Send message"}</Button>
        </form>
        <div className="space-y-3 text-sm text-slate-600 lg:col-span-5">
          <p className="font-semibold text-[#0B2D5B]">clockaroo.com.au</p>
          <p>Email: [Contact email TBC]</p>
          <p>Phone: [Phone TBC]</p>
        </div>
      </section>
    </div>
  );
};
